import React from 'react'
import { Button } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import _ from 'lodash'
import axios from 'axios'
import endpoints from 'services/endpoints'
import moment from 'moment'
import { injectIntl } from 'react-intl'
import { showErrorMessage } from 'services/handleErrors'
import errorBoundaryEnhancer from 'services/errorBoundaryEnhancer'
import { redirectTo } from 'services/router'
import { withProfile } from 'redux/enhancers'
import SpinLoader from 'components/SpinLoader'
import { temporaryFilter } from '../../news/utils'
import style from './style.module.scss'

const formatDate = d => moment(d).format('DD MMMM YYYY')

class News extends React.Component {
  state = {
    loading: false,
    posts: []
  }

  componentDidMount() {
    this.getPosts()
  }

  getPosts = () => {
    const { user: { qualification } } = this.props

    this.setState({ loading: true })

    axios
      .post(endpoints.getPosts, { limit: 10, qualification })
      .then(res => {

        const posts = temporaryFilter(_.get(res, 'data.posts', []), qualification).slice(0, 3)
        this.setState({ posts, loading: false })
      })
      .catch(err => {
        this.setState({ loading: false })
        showErrorMessage(err)
      })
  }

  renderContent = () => {
    const { posts, loading } = this.state;
    const { formatMessage } = this.props.intl;

    if (loading)
      return <SpinLoader className={style.loader} />

    if (posts.length > 0) {
      return (
        <>
          {posts.map(post => (
            <div className={style.post} key={post.id}>
              <div className={style.date}>{formatDate(post.createdAt)}</div>
              <h3>{post.title}</h3>
              <div dangerouslySetInnerHTML={{ __html: post.shortBody }} className={style.shortBody} />
            </div>
          ))}
          <Button
            onClick={() => redirectTo('/news')}
            className={style.showAll}
            icon={<PlusOutlined />}
          >
            {formatMessage({ id: 'page.dashboard.news.show-all' })}
          </Button>
        </>
      )
    }

    return (
      <>
        <h3>{formatMessage({ id: 'page.dashboard.news.title' })}</h3>
        <div className={style.empty}>{formatMessage({ id: 'page.dashboard.news.empty' })}</div>
      </>
    )
  }

  render() {
    return (
      <div className={style.news}>
        {this.renderContent()}
      </div>
    )
  }
}

export default errorBoundaryEnhancer(injectIntl(withProfile(News)))
